<template>
  <div>
    <md-dialog
      :md-active.sync="showDialog"
      class="mkt-ops -main-font volumepricing dialog-update"
      :md-click-outside-to-close="clickOutside"
    >
      <div
        style="position: absolute;top: 50%; left: 52%; width: 10%; z-index: 2;"
        v-show="loadData == true"
      >
        <md-progress-spinner
          :md-stroke="8"
          :md-diameter="65"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>

      <md-dialog-title v-if="value._id === undefined"
        >Create a Volume Pricing Group</md-dialog-title
      >
      <md-dialog-title v-else>
        <div class="title-panel">
          {{
            displayData == true
              ? "Detail Volume Pricing Group"
              : "Edit Volume Pricing Group"
          }}
        </div>
        <md-menu md-size="big">
          <md-button
            v-if="displayData == true && isOwner(value.c_user) && isEdit"
            class="md-primary -edit"
            @click="onClickEdit()"
            >EDIT</md-button
          >
          <md-button
            v-if="isOwner(value.c_user) && isDelete"
            class="md-icon-button more-vert"
            md-menu-trigger
          >
            <md-icon>more_vert</md-icon>
          </md-button>
          <md-menu-content class="menu-vert-volume">
            <md-menu-item @click="onClickDelete()">
              <span>Delete</span>
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </md-dialog-title>

      <div class="layout-dialog">
        <div class="dialog-left-panel">
          <div
            class="md-layout layout-input-value"
            style="padding-left: 0px; display: block;"
          >
            <div class="md-layout-item">
              <div class="md-layout layout-input-value">
                <div
                  v-if="displayData == true && value._id !== undefined"
                  style="width: 100%;"
                >
                  <div><label>Title</label></div>
                  <!-- <div class="display-mode -font-kanit nowrap-title"><label :title="vTitle">{{vTitle}}</label></div> -->
                  <div class="display-mode -font-kanit nowrap-title">
                    <label :title="vTitle">{{
                      checkLengthString(vTitle)
                    }}</label>
                  </div>

                  <!-- <div v-show="((vDetail) && vDetail != '')" style="margin-top: 12px;"><label>Detail</label></div>
                                <div class="display-mode -font-kanit"><div class="-detail">{{vDetail}}</div></div> -->
                  <div class="-textarea">
                    <label>Detail</label>
                    <textarea
                      v-model="vDetail"
                      placeholder="Please enter Detail."
                      :disabled="true"
                    ></textarea>
                  </div>

                  <div style="width: 100%; display: flex;">
                    <div style="width: 35%; margin-top: 12px;">
                      <label>Type</label>
                    </div>
                  </div>
                  <div style="width: 100%; display: flex;">
                    <div style="width: 35%;" class="display-mode -font-kanit">
                      <label>{{
                        mixSwitch == true ? "Mixable" : "Independent"
                      }}</label>
                    </div>
                  </div>
                </div>

                <div v-else class="md-layout layout-input-value">
                  <md-field
                    class="md-has-value"
                    style="width: 95%; margin-bottom: 10px;"
                  >
                    <label>Title</label>
                    <md-input v-model="vTitle" class="-font-kanit"></md-input>
                  </md-field>

                  <div class="-textarea">
                    <label>Detail</label>
                    <textarea
                      v-model="vDetail"
                      placeholder="Please enter Detail."
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="md-layout layout-input-value -textarea">
                    <div v-if="displayData == true && value._id !== undefined" style="width: 100%;">
                        <div><label>Detail</label></div>
                        <div class="display-mode -font-kanit nowrap-title"><label>{{vDetail}}</label></div>
                    </div>
                    <div v-else class="md-layout layout-input-value">
                        <label>Detail</label>
                        <textarea v-model="vDetail" placeholder="Please enter Detail."></textarea>
                    </div>
                </div> -->

          <div class="md-layout layout-input-value">
            <div class="md-layout-item quantity-condition">
              <div class="display-flex">
                <div class="con-type"></div>
                <div style="width: 160px;">QUANTITY CONDITION</div>
              </div>
              <div class="display-flex" style="margin-top: 7px;">
                <div class="con-type"></div>
                <div class="value-type">Start</div>
                <div class="-null"></div>
                <div class="value-type">End</div>
              </div>
              <div class="-group-condition">
                <div class="display-flex" style="margin-top: 0px;">
                  <div class="con-type">A3 &ensp;</div>
                  <div class="value-type">
                    <md-field class="-md-input input-disabled">
                      <md-input
                        type="text"
                        v-model="A3_start"
                        @keypress.native="isNumber"
                        @focus.native="$event.target.select()"
                        :disabled="disabledInputStart"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="-null">&ensp; - &ensp;</div>
                  <div class="value-type">
                    <md-field
                      :class="
                        disabledInput ? '-md-input input-disabled' : '-md-input'
                      "
                    >
                      <md-input
                        type="text"
                        v-model="A3"
                        @keypress.native="isNumber"
                        @blur="defaultValueStart"
                        @focus.native="$event.target.select()"
                        :disabled="disabledInput"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="display-flex">
                  <div class="con-type">C3 &ensp;</div>
                  <div class="value-type">
                    <md-field class="-md-input input-disabled">
                      <md-input
                        type="text"
                        v-model="C3_start"
                        @keypress.native="isNumber"
                        @focus.native="$event.target.select()"
                        :disabled="disabledInputStart"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="-null">&ensp; - &ensp;</div>
                  <div class="value-type">
                    <md-field
                      :class="
                        disabledInput ? '-md-input input-disabled' : '-md-input'
                      "
                    >
                      <md-input
                        type="text"
                        v-model="C3"
                        @keypress.native="isNumber"
                        @blur="defaultValueStart"
                        @focus.native="$event.target.select()"
                        :disabled="disabledInput"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="display-flex">
                  <div class="con-type">C2 &ensp;</div>
                  <div class="value-type">
                    <md-field class="-md-input input-disabled">
                      <md-input
                        type="text"
                        v-model="C2_start"
                        @keypress.native="isNumber"
                        @focus.native="$event.target.select()"
                        :disabled="disabledInputStart"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="-null">&ensp; - &ensp;</div>
                  <div class="value-type">
                    <md-field
                      :class="
                        disabledInput ? '-md-input input-disabled' : '-md-input'
                      "
                    >
                      <md-input
                        type="text"
                        v-model="C2"
                        @keypress.native="isNumber"
                        @blur="defaultValueStart"
                        @focus.native="$event.target.select()"
                        :disabled="disabledInput"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="display-flex">
                  <div class="con-type">C1 &ensp;</div>
                  <div class="value-type">
                    <md-field class="-md-input input-disabled">
                      <md-input
                        type="text"
                        v-model="C1_start"
                        @keypress.native="isNumber"
                        @focus.native="$event.target.select()"
                        :disabled="disabledInputStart"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="-null">&ensp; - &ensp;</div>
                  <div class="value-type">
                    <md-field
                      :class="
                        disabledInput ? '-md-input input-disabled' : '-md-input'
                      "
                    >
                      <md-input
                        type="text"
                        v-model="C1"
                        @keypress.native="isNumber"
                        @blur="defaultValueStart"
                        @focus.native="$event.target.select()"
                        :disabled="disabledInput"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="display-flex">
                  <div class="con-type">C0 &ensp;</div>
                  <div class="value-type">
                    <md-field class="-md-input input-disabled">
                      <md-input
                        type="text"
                        v-model="C0_start"
                        @keypress.native="isNumber"
                        @focus.native="$event.target.select()"
                        :disabled="disabledInputStart"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="-null">&ensp; - &ensp;</div>
                  <div class="con-type">MORE</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dialog-right-panel">
          <div
            v-if="displayData == false || value._id === undefined"
            class="md-layout"
          >
            <div class="-txt-items" style="width: 17%;">ITEMS IN GROUP</div>
            <div class="mktops-control-box" style="width: 46%;">
              <treeselect
                ref="productTxt"
                class="treeview-box"
                :multiple="true"
                :limit="1"
                :maxHeight="400"
                placeholder="+ Add with Product Code"
                :async="true"
                :load-options="loadOptions"
                :cache-options="false"
                v-model="valueTree"
                :value-consists-of="valueConsistsOf"
                :clearable="false"
                @select="openOnSelectTreeview"
                @deselect="onDeSelectTreeview"
                @open="onOpenTreeview"
              >
                <label
                  slot="option-label"
                  slot-scope="{ node }"
                  :title="node.label"
                  class="nowrap-title"
                  >{{ node.raw.code }} - {{ node.label }}</label
                >
              </treeselect>
            </div>
            <i
              class="material-icons"
              title="Search by product name"
              style="margin-top: 20px; margin-left: 15px; cursor: pointer; width: 3%;"
              @click="onClickDialogFilter()"
              >filter_list</i
            >
            <div class="filter-table" style="width: 27%;">
              <input
                type="text"
                v-model="vFilter"
                placeholder="Search by product code, product name...."
                @keyup="filterTable"
              />
            </div>
            <div style="width: 5%; text-align: right; margin-top: 20px;">
              <i
                class="md-icon material-icons -delete-back"
                title="Delete"
                @click="deleteProduct"
                >delete_sweep</i
              >
            </div>
          </div>

          <div class="md-layout" style="padding-left: 2px; margin-top: 5px;">
            <div
              class="md-layout-item md-large-size-100 md-medium-size-100 md-small-size-100"
            >
              <div id="table-update-scroll">
                <div
                  id="divHeadUpdate"
                  :class="
                    displayData == true && value._id !== undefined
                      ? 'display'
                      : ''
                  "
                >
                  <div
                    v-if="displayData == false || value._id === undefined"
                    style="width: 3.5%;"
                  >
                    <label class="-mkt-checkbox-container">
                      <input
                        type="checkbox"
                        @click="selectAll"
                        v-model="checkedProductsAll"
                      />
                      <span class="-mkt-checkbox"></span>
                    </label>
                  </div>
                  <div style="width: 6.5%;">Code</div>
                  <div
                    :style="
                      displayData == false || value._id === undefined
                        ? 'width: 25%;'
                        : 'width: 28.5%;'
                    "
                  >
                    Product
                  </div>
                  <div style="width: 6%;" class="-text-right">Stock</div>
                  <div style="width: 7%;" class="-text-right">Cost</div>
                  <div style="width: 9%;" class="-text-right">A3</div>
                  <div style="width: 7%;" class="-text-right">C3</div>
                  <div style="width: 7%;" class="-text-right">C2</div>
                  <div style="width: 7%;" class="-text-right">C1</div>
                  <div style="width: 7%;" class="-text-right">C0</div>
                  <div style="width: 7%; padding-left: 35px;">Unit</div>
                  <div v-show="showGP" style="width: 8%;" class="-text-right">
                    GP
                  </div>
                  <!-- <div style="width: 10%;" class="-text-right">Total</div> -->
                </div>
                <div
                  id="divBodyUpdate"
                  :class="
                    displayData == true && value._id !== undefined
                      ? 'display'
                      : ''
                  "
                >
                  <div
                    :class="'row-bg-gray'"
                    v-for="(item, updateIndex) in createDatas"
                    :key="updateIndex"
                  >
                    <div
                      v-if="displayData == false || value._id === undefined"
                      style="width: 3.5%;"
                    >
                      <label class="-mkt-checkbox-container">
                        <input
                          type="checkbox"
                          v-model="checkedProducts"
                          :id="item.item_code"
                          :value="item.item_code"
                        />
                        <span class="-mkt-checkbox"></span>
                      </label>
                    </div>
                    <div style="width: 6.5%;">{{ item.item_code }}</div>
                    <div
                      :style="
                        displayData == false || value._id === undefined
                          ? 'width: 25%;'
                          : 'width: 28.5%;'
                      "
                      class="nowrap-title -font-kanit"
                    >
                      <span :title="item.item_name">{{ item.item_name }}</span>
                    </div>
                    <div style="width: 6%;" class="-text-right">
                      {{ item.stock != "" ? item.stock : "" }}
                    </div>
                    <div style="width: 7%;" class="-text-right">
                      {{ item.cost != "" ? formatNumber(item.cost, 2) : "" }}
                    </div>
                    <div style="width: 9%;" class="-text-right">
                      {{
                        item.qty_a3 != "" ? formatNumber(item.qty_a3, 2) : ""
                      }}
                    </div>
                    <div style="width: 7%;" class="-text-right">
                      {{
                        item.qty_c3 != "" ? formatNumber(item.qty_c3, 2) : ""
                      }}
                    </div>
                    <div style="width: 7%;" class="-text-right">
                      {{
                        item.qty_c2 != "" ? formatNumber(item.qty_c2, 2) : ""
                      }}
                    </div>
                    <div style="width: 7%;" class="-text-right">
                      {{
                        item.qty_c1 != "" ? formatNumber(item.qty_c1, 2) : ""
                      }}
                    </div>
                    <div style="width: 7%;" class="-text-right">
                      {{
                        item.qty_c0 != "" ? formatNumber(item.qty_c0, 2) : ""
                      }}
                    </div>
                    <div
                      style="width: 7%; padding-left: 35px;"
                      class="-font-kanit"
                    >
                      <!-- {{ item.saleprice_um_title }} -->
                      {{ (!item.selling_um_title || item.selling_um_title == '') ? item.saleprice_um_title : item.selling_um_title }}
                    </div>
                    <div v-show="showGP" style="width: 8%;" class="-text-right">
                      {{ calGPbyRow(item) }}
                    </div>
                  </div>
                </div>
                <div id="divTableFoot">
                  <div style="width: 35%;" class="-text-right">Sum of :</div>
                  <div style="width: 8%;" class="-text-right">
                    {{ formatNumber(sumCost, 2) }}
                  </div>
                  <div style="width: 9%;" class="-text-right">
                    {{ formatNumber(sumA3, 2) }}
                  </div>
                  <div style="width: 24%;"></div>
                  <div style="width: 8%;" class="-text-right">
                    {{ formatNumber(sumC0, 2) }}
                  </div>
                  <div style="width: 8%;"></div>
                  <div v-show="showGP" style="width: 8%;" class="-text-right">
                    {{ formatNumber(sumGP, 2) }}
                  </div>
                </div>
                <div class="footer-table">
                  number of product ({{ createDatas.length }})
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <md-dialog-actions class="-action">
        <div class="md-switch">
          <md-switch
            v-if="displayData == false || value._id === undefined"
            v-model="mixSwitch"
            @change="switchCheck"
            >Mixable Purchase</md-switch
          >
        </div>
        <div class="md-button">
          <md-button class="md-primary -cancel" @click="onClickCancel()">{{
            displayData == false || value._id === undefined ? "CANCEL" : "CLOSE"
          }}</md-button>
          <md-button
            v-if="displayData == false || value._id === undefined"
            class="md-primary -confirm"
            @click="onClickSave()"
            >{{ value._id === undefined ? "CREATE" : "SAVE" }}</md-button
          >
        </div>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      :md-active.sync="showDialogAlert"
      class="mkt-ops -main-font volumepricing dialog-alert"
      :md-click-outside-to-close="clickOutside"
    >
      <md-dialog-title v-if="value._id === undefined"
        >Alert Message</md-dialog-title
      >
      <div class="layout-dialog">
        <div class="dialog-content">
          <div style="font-weight: bold; width: 20%;">
            Lost product : &ensp;
          </div>
          <div style="width: 80%;" class="scrollbar">
            {{ alertProductLost }}
          </div>
        </div>
        <div class="dialog-content -conditions" style="width: 92%;">
          <div class="title" style="width: 100%;">Check conditions</div>
          <div style="width: 100%;">
            <ul>
              <li>Product ที่มีสถานะเป็น Inactive จะไม่นำมาแสดง</li>
              <li>
                Product ที่มี Product Lift Cycle นอกจากที่กำหนดไว้ จะไม่นำมาแสดง
              </li>
              <li>
                Product ที่มีอยู่ใน Volume Discount ตัวอื่นแล้ว จะไม่นำมาแสดง
              </li>
              <li>
                Product ที่มี Item Group = BM3 : Materials Product Pur. (Local)
                และ BM5 : Materials Product Pur (Import) จะไม่นำมาแสดง
              </li>
            </ul>
          </div>
        </div>
      </div>
      <md-dialog-actions class="-action">
        <md-button class="md-primary -confirm" @click="showDialogAlert = false"
          >OK</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      :md-active.sync="showDialogFilter"
      class="dialog-filter-product -w90"
      :md-click-outside-to-close="false"
    >
      <div :class="loadData ? 'bg-backdrop-pricing' : ''"></div>
      <div
        style="position: absolute;top: 50%; left: 50%; width: 10%; z-index: 15;"
        v-show="loadData == true"
      >
        <md-progress-spinner
          :md-stroke="8"
          :md-diameter="65"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>

      <md-dialog-title>All Product</md-dialog-title>
      <div class="layout-dialog" style="display: flex;">
        <div class="md-layout-item md-large-size-30 md-medium-size-30">
          <div style="width: 100%;">
            <div style="margin: 10px 5px 13px 5px;">
              <multiselect
                v-model="selectedProoductGroup"
                id="group"
                label="title"
                track-by="code"
                placeholder="All Product Group"
                :open-direction="'bottom'"
                :options="optionsProoductGroup"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelProoduct"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
                @select="setDataProoduct"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div class="-label">
                      {{ option.code }} - {{ option.title }}
                    </div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="clearAll(option.code, 'group')"
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div style="width: 100%;">
            <div style="margin: 10px 5px 13px 5px;">
              <multiselect
                v-model="selectedProoductSubGroup"
                id="subgroup"
                label="title"
                track-by="code"
                placeholder="All Sub Group"
                :open-direction="'bottom'"
                :options="optionsProoductSubGroup"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelProoduct"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
                @select="setDataProoduct"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div class="-label">
                      {{ option.code }} - {{ option.title }}
                    </div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="
                        clearAll(option.code, 'subgroup')
                      "
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div style="width: 100%;">
            <div style="margin: 10px 5px 13px 5px;">
              <multiselect
                v-model="selectedProoductCG"
                id="cg"
                label="title"
                track-by="code"
                placeholder="All CG"
                :open-direction="'bottom'"
                :options="optionsProoductCG"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelProoduct"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
                @select="setDataProoduct"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div class="-label">
                      {{ option.code }} - {{ option.title }}
                    </div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="clearAll(option.code, 'cg')"
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div class="filter-table" style="width: 100%;">
            <input
              type="text"
              v-model="searchFilterProductCode"
              placeholder="Search by product code...."
            />
          </div>

          <div class="filter-table" style="width: 100%; margin-top: 10px;">
            <input
              type="text"
              v-model="searchFilterProductName"
              placeholder="Search by product name...."
            />
          </div>

          <div
            style="width: 100%; margin-top: 15px; font-style: italic; font-weight: 300; color: #b6b6b6; padding-left: 20px;"
          >
            ** Product ที่มีอยู่ใน Volume Discount ตัวอื่นแล้ว
          </div>

          <div style="text-align: center; margin-top: 20px;">
            <md-button
              class="md-raised md-primary filter-search"
              @click="searchProduct()"
              >SEARCH</md-button
            >
          </div>
        </div>

        <div
          class="md-layout-item md-large-size-70 md-medium-size-70 mkt-ops -main-font"
          style="padding-left: 25px;"
        >
          <div id="table-product-filter">
            <div id="divHeadList">
              <div style="width: 4.5%;">
                <label class="-mkt-checkbox-container">
                  <input
                    type="checkbox"
                    @click="selectAllProductFilter"
                    v-model="checkedProductFilterAll"
                  />
                  <span class="-mkt-checkbox"></span>
                </label>
              </div>
              <!-- <div style="width: 6.5%;">Code</div>
                        <div style="width: 25%;">Product</div>
                        <div style="width: 8%;" class="-text-right">Cost</div>
                        <div style="width: 9%;" class="-text-right">A3</div>
                        <div style="width: 8%;" class="-text-right">C3</div>
                        <div style="width: 8%;" class="-text-right">C2</div>
                        <div style="width: 8%;" class="-text-right">C1</div>
                        <div style="width: 8%;" class="-text-right">C0</div>
                        <div style="width: 8%; padding-left: 35px;">Unit</div>
                        <div style="width: 8%;" class="-text-right">GP</div> -->
              <div style="width: 9.5%;">Code</div>
              <div style="width: 70%;">Product</div>
              <div style="width: 16%; padding-left: 35px;">Unit</div>
            </div>
            <div id="divBodyList">
              <div
                v-show="tbListProduct == null || tbListProduct.length == 0"
                :class="'row-bg-gray'"
                style="display: block; text-align: center;"
              >
                No data in table.
              </div>
              <div
                :class="item.used ? 'row-bg-gray -disabled' : 'row-bg-gray'"
                v-for="(item, rIndex) in tbListProduct"
                :key="rIndex"
              >
                <div
                  v-show="item.used === undefined || item.used == false"
                  style="width: 4.5%;"
                >
                  <label class="-mkt-checkbox-container">
                    <input
                      type="checkbox"
                      v-model="checkedProductFilter"
                      :id="item.code"
                      :value="item.code"
                      @click="selectProductFilter(item.code)"
                    />
                    <span class="-mkt-checkbox"></span>
                  </label>
                </div>
                <div v-show="item.used" style="width: 4.5%;">
                  <label class="-mkt-checkbox-container">
                    <span class="-mkt-checkbox -disabled"></span>
                  </label>
                </div>
                <!-- <div style="width: 6.5%;">{{ item.code }}</div>
                            <div style="width: 25%;" class="nowrap-title -font-kanit">
                                <span :title="item.item_name">{{ item.item_name }}</span>
                            </div>
                            <div style="width: 8%;" class="-text-right">{{ formatNumber(item.cost, 2) }}</div>
                            <div style="width: 9%;" class="-text-right">{{ (item.price && item.price.A3 && item.price.A3 != null) ? formatNumber(item.price.A3, 2) : formatNumber(0, 2) }}</div>
                            <div style="width: 8%;" class="-text-right">{{ (item.price && item.price.C3 && item.price.C3 != null) ? formatNumber(item.price.C3, 2) : formatNumber(0, 2) }}</div>
                            <div style="width: 8%;" class="-text-right">{{ (item.price && item.price.C2 && item.price.C2 != null) ? formatNumber(item.price.C2, 2) : formatNumber(0, 2) }}</div>
                            <div style="width: 8%;" class="-text-right">{{ (item.price && item.price.C1 && item.price.C1 != null) ? formatNumber(item.price.C1, 2) : formatNumber(0, 2) }}</div>
                            <div style="width: 8%;" class="-text-right">{{ (item.price && item.price.C0 && item.price.C0 != null) ? formatNumber(item.price.C0, 2) : formatNumber(0, 2) }}</div>
                            <div style="width: 8%; padding-left: 35px;" class="-font-kanit">{{ item.selling_um_title }}</div>
                            <div style="width: 8%;" class="-text-right">{{ calGPbyRow(item) }}</div> -->
                <div style="width: 9.5%;">{{ item.code }}</div>
                <div style="width: 70%;" class="nowrap-title -font-kanit">
                  <span :title="item.item_name">{{ item.item_name }}</span>
                </div>
                <div
                  style="width: 16%; padding-left: 35px;"
                  class="-font-kanit"
                >
                  {{ item.selling_um_title }}
                </div>
              </div>
            </div>
            <div class="footer-table">
              number of lines in table ({{ tbListProduct.length }})
            </div>
          </div>
        </div>
      </div>

      <md-dialog-actions class="-action">
        <md-button class="md-primary -cancel" @click="onClickClose()"
          >CLOSE</md-button
        >
        <md-button
          :class="
            disableAddData && checkedProductFilter.length == 0
              ? 'md-primary -save -disabled'
              : 'md-primary -save'
          "
          :disabled="disableAddData"
          @click="onclickAddProduct()"
          >ADD TO TABLE</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>

    <md-dialog-confirm
      :md-active.sync="showDialogMix"
      :md-content="dContent"
      :md-click-outside-to-close="clickOutside"
      md-confirm-text="OK"
      md-cancel-text="CLOSE"
      @md-cancel="onClose"
      @md-confirm="onOk"
    />
    <md-dialog-confirm
      :md-active.sync="showDialogCancel"
      :md-click-outside-to-close="clickOutside"
      md-content="Are you sure you want to cancel changes ?"
      md-confirm-text="OK"
      md-cancel-text="CANCEL"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
    <md-dialog-confirm
      :md-active.sync="showDialogSave"
      :md-click-outside-to-close="clickOutside"
      :md-content="dContent"
      md-confirm-text="OK"
      md-cancel-text="CANCEL"
      @md-cancel="onCancel"
      @md-confirm="onSave"
    />
    <md-dialog-confirm
      :md-active.sync="showDialogDeleteProduct"
      :md-click-outside-to-close="clickOutside"
      md-content="Are you sure you want to delete ?"
      md-confirm-text="OK"
      md-cancel-text="CANCEL"
      @md-cancel="onCancel"
      @md-confirm="onDeleteProduct"
    />
    <md-dialog-confirm
      :md-active.sync="showDialogDeleteItem"
      :md-click-outside-to-close="clickOutside"
      :md-content="dContent"
      md-confirm-text="OK"
      md-cancel-text="CANCEL"
      @md-cancel="onCancel"
      @md-confirm="onDeleteItem"
    />
  </div>
</template>

<script>
import moment from "moment-timezone";
import PricingService from "@/services/pricing";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 2000);
};

export default {
  name: "dialogupdatediscount",
  props: ["value", "dataDetail"],
  components: {
    Treeselect
  },
  created() {
    let dataUser = this.$jwt.decode(localStorage.getItem("token"));
    if (dataUser.group !== "Trade Marketer") {
      this.showGP = true;
    }
  },
  computed: {
    user() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isEdit() {
      return this.user.acl["overview"].menus["volume-pricing"].edit;
    },
    isDelete() {
      return this.user.acl["overview"].menus["volume-pricing"].delete;
    }
  },
  watch: {},
  data() {
    return {
      loadData: false,
      disabledInputStart: true,
      disabledInput: this.value._id === undefined ? false : true,
      displayData: true,
      rowBgGray: false,
      showDialog: true,
      showDialogAlert: false,
      vTitle: "",
      vDetail: "",
      vDesscription: " ",
      mixSwitch: true,
      createDatas: [],
      makeDataDetail: [],
      C3: 0,
      C2: 0,
      C1: 0,
      C0: 0,
      A3: 0,
      C3_start: 0,
      C2_start: 0,
      C1_start: 0,
      C0_start: 0,
      A3_start: 1,
      showDialogMix: false,
      showDialogSave: false,
      showDialogDeleteProduct: false,
      showDialogDeleteItem: false,
      dContent: "",
      showSnackbar: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      checkedProductsAll: false,
      checkedProducts: [],
      checkedLengthProducts: [],
      showDialogCancel: false,
      dataDelete: [],
      clickOutside: false,
      valueTree: [],
      optionsTreeview: [],
      dataTreeview: [],
      dataLoaded: [],
      valueConsistsOf: "LEAF_PRIORITY",
      vFilter: "",
      arrsTable: [],
      createDatasOld: [],
      checkDataDelete: [],
      sumCost: 0,
      sumA3: 0,
      sumC0: 0,
      sumGP: 0,
      showGP: false,
      alertProductLost: "",
      showDialogFilter: false,
      selectedProoductGroup: [],
      optionsProoductGroup: [],
      selectedProoductSubGroup: [],
      optionsProoductSubGroup: [],
      selectedProoductCG: [],
      optionsProoductCG: [],
      searchFilterProductCode: "",
      searchFilterProductName: "",
      tbListProduct: [],
      checkedProductFilter: [],
      checkedProductFilterAll: false,
      disableAddData: true
    };
  },
  mounted() {
    let self = this;

    if (this.value._id !== undefined) {
      this.createDatas = this.dataDetail;
      this.createDatas.sort((a, b) => (a.item_code > b.item_code ? 1 : -1));

      this.dataDelete = JSON.parse(JSON.stringify(this.dataDetail));
      this.makeDataDetail = this.dataDetail;
      this.vTitle = this.value.h_name;
      this.vDetail = this.value.h_detail;
      this.vDesscription = this.value.desc;
      this.A3_start =
        this.value.qty_a3[0].start == "" || this.value.qty_a3[0].start == null
          ? 0
          : this.value.qty_a3[0].start;
      this.A3 =
        this.value.qty_a3[0].end == "" || this.value.qty_a3[0].end == null
          ? 0
          : this.value.qty_a3[0].end;
      if (this.value.qty_c3 != null) {
        this.C3_start =
          this.value.qty_c3[0].start == "" || this.value.qty_c3[0].start == null
            ? 0
            : this.value.qty_c3[0].start;
        this.C3 =
          this.value.qty_c3[0].end == "" || this.value.qty_c3[0].end == null
            ? 0
            : this.value.qty_c3[0].end;
      }
      this.C2_start =
        this.value.qty_c2[0].start == "" || this.value.qty_c2[0].start == null
          ? 0
          : this.value.qty_c2[0].start;
      this.C2 =
        this.value.qty_c2[0].end == "" || this.value.qty_c2[0].end == null
          ? 0
          : this.value.qty_c2[0].end;
      this.C1_start =
        this.value.qty_c1[0].start == "" || this.value.qty_c1[0].start == null
          ? 0
          : this.value.qty_c1[0].start;
      this.C1 =
        this.value.qty_c1[0].end == "" || this.value.qty_c1[0].end == null
          ? 0
          : this.value.qty_c1[0].end;
      this.C0_start =
        this.value.qty_c0[0].start == "" || this.value.qty_c0[0].start == null
          ? 0
          : this.value.qty_c0[0].start;
      if (this.value.type == "Mixable") {
        this.mixSwitch = true;
      } else {
        this.mixSwitch = false;
      }

      this.createDatasOld = JSON.parse(JSON.stringify(this.dataDetail));

      this.sumCost = 0;
      this.sumA3 = 0;
      this.sumC0 = 0;
      this.sumGP = 0;
      this.createDatasOld.forEach(function(value, key) {
        let vCost = value.cost && value.cost != "" ? value.cost : 0;
        let commaCost = parseFloat(
          self.formatNumber(vCost, 2).replace(",", "")
        );
        let calCost = Math.round(parseFloat(commaCost) * 100) / 100;

        let vA3 = value.qty_a3 && value.qty_a3 != "" ? value.qty_a3 : 0;
        let vC0 = value.qty_c0 && value.qty_c0 != "" ? value.qty_c0 : 0;
        let commaA3 = parseFloat(self.formatNumber(vA3, 2).replace(",", ""));
        let commaC0 = parseFloat(self.formatNumber(vC0, 2).replace(",", ""));
        let calA3 = Math.round(parseFloat(commaA3) * 100) / 100;
        let calC0 = Math.round(parseFloat(commaC0) * 100) / 100;

        self.sumCost += calCost;
        self.sumA3 += calA3;
        self.sumC0 += calC0;
      });

      let comCOST = parseFloat(
        self.formatNumber(this.sumCost, 2).replace(",", "")
      );
      let COST = Math.round(parseFloat(comCOST) * 100) / 100;
      let comA3 = parseFloat(self.formatNumber(this.sumA3, 2).replace(",", ""));
      let comC0 = parseFloat(self.formatNumber(this.sumC0, 2).replace(",", ""));
      let A3 = Math.round(parseFloat(comA3) * 100) / 100;
      let C0 = Math.round(parseFloat(comC0) * 100) / 100;
      // this.sumGP = (A3 == 0) ? 0 : ((A3 - COST) / A3) * 100;
      this.sumGP = C0 == 0 ? 0 : ((C0 - COST) / C0) * 100;
    }

    this.dataDelete.forEach(function(value, key) {
      self.valueTree.push(value.id);
    });
  },
  methods: {
    checkLengthString(text) {
      if (text.length > 36) {
        return text.substring(0, 35) + "...";
      } else {
        return text;
      }
    },
    getAllProduct(datas) {
      PricingService.getAllProduct(datas)
        .then(response => {
          if (response) {
            this.optionsProoductGroup =
              response.data.product_group !== undefined
                ? response.data.product_group.sort((a, b) =>
                    a.code > b.code ? 1 : -1
                  )
                : [];
            this.optionsProoductSubGroup =
              response.data.product_subgroup !== undefined
                ? response.data.product_subgroup.sort((a, b) =>
                    a.code > b.code ? 1 : -1
                  )
                : [];
            this.optionsProoductCG =
              response.data.product_cg !== undefined
                ? response.data.product_cg.sort((a, b) =>
                    a.code > b.code ? 1 : -1
                  )
                : [];

            if (datas !== undefined && datas.type == "subgroup") {
              this.selectedProoductGroup = response.data.product_group[0];
            } else if (datas !== undefined && datas.type == "cg") {
              this.selectedProoductGroup = response.data.product_group[0];
              this.selectedProoductSubGroup = response.data.product_subgroup[0];
            }

            this.loadData = false;
          }
        })
        .catch();
    },
    getAllProductSearch(datas) {
      // PricingService.getAllProductSearch(datas).then(response => {
      this.loadData = true;
      let text = datas.code;
      let type = "filter";
      let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
      PricingService.ProductTree(text, type, [], emp_code, "popup", datas)
        .then(response => {
          if (response) {
            this.tbListProduct =
              response.data !== undefined
                ? response.data.sort((a, b) => (a.code > b.code ? 1 : -1))
                : [];
          }
          this.checkedProductFilterAll = false;
          this.loadData = false;
        })
        .catch();
    },
    onClickDialogFilter() {
      this.getAllProduct();
      this.showDialogFilter = true;
      this.loadData = true;
    },
    customLabelProoduct({ code, title }) {
      return `${code} - ${title}`;
    },
    setDataProoduct(selectedOption, id) {
      let datas = { type: id, code: selectedOption.code };
      this.getAllProduct(datas);
    },
    selectAllProductFilter() {
      this.checkedProductFilter = [];
      if (!this.checkedProductFilterAll) {
        for (let itemCode in this.tbListProduct) {
          if (
            this.tbListProduct[itemCode].used === undefined ||
            this.tbListProduct[itemCode].used == false
          ) {
            this.checkedProductFilter.push(this.tbListProduct[itemCode].code);
          }
        }
        this.disableAddData =
          this.checkedProductFilter.length > 0 ? false : true;
      } else {
        this.disableAddData =
          this.checkedProductFilter.length > 0 ? false : true;
      }
    },
    selectProductFilter(code) {
      if (this.checkedProductFilter.indexOf(code) == -1) {
        this.checkedProductFilter.push(code);
      } else {
        this.checkedProductFilter.splice(
          this.checkedProductFilter.indexOf(code),
          1
        );
      }

      this.disableAddData = this.checkedProductFilter.length > 0 ? false : true;
    },
    searchProduct() {
      let v_group = this.selectedProoductGroup.code;
      let v_subgroup = this.selectedProoductSubGroup.code;
      let v_cg = this.selectedProoductCG.code;
      if (
        (v_group == "" || v_group == null) &&
        (v_subgroup == "" || v_subgroup == null) &&
        (v_cg == "" || v_cg == null) &&
        (this.searchFilterProductCode == "" ||
          this.searchFilterProductCode == null) &&
        (this.searchFilterProductName == "" ||
          this.searchFilterProductName == null)
      ) {
        this.showSnackbar = true;
        this.dContent =
          "Please select or fill in the input you want to search.";
      } else {
        let datas = {
          group: v_group,
          subgroup: v_subgroup,
          cg: v_cg,
          code: this.searchFilterProductCode,
          name: this.searchFilterProductName
        };
        this.getAllProductSearch(datas);
      }
    },
    clearAll(id, type) {
      if (type == "group") {
        this.selectedProoductGroup = [];
        this.selectedProoductSubGroup = [];
        this.selectedProoductCG = [];
        this.getAllProduct();
      } else if (type == "subgroup") {
        let datas = { type: "group", code: this.selectedProoductGroup.code };
        this.selectedProoductSubGroup = [];
        this.selectedProoductCG = [];
        this.getAllProduct(datas);
      } else if (type == "cg") {
        let datas = {
          type: "subgroup",
          code: this.selectedProoductSubGroup.code
        };
        this.selectedProoductCG = [];
        this.getAllProduct(datas);
      }
    },
    onClickClose() {
      this.selectedProoductGroup = [];
      this.selectedProoductSubGroup = [];
      this.selectedProoductCG = [];
      this.searchFilterProductCode = "";
      this.searchFilterProductName = "";
      this.tbListProduct = [];
      this.showDialogFilter = false;
      this.checkedProductFilterAll = false;
      this.checkedProductFilter = [];
    },
    onclickAddProduct() {
      for (let i = 0; i < this.tbListProduct.length; i++) {
        let index = this.createDatas.findIndex(
          item => item.code === this.tbListProduct[i].code
        );
        if (index < 0) {
          // this.products.push(this.tbListProduct[i])
          if (
            this.checkedProductFilter.indexOf(this.tbListProduct[i].code) > -1
          ) {
            this.valueTree = _.union(this.valueTree, [
              this.tbListProduct[i].id
            ]);
            this.openOnSelectTreeview(this.tbListProduct[i]);
          }
        }
      }
      this.showDialogFilter = false;
      this.disableAddData = true;

      this.selectedProoductGroup = [];
      this.selectedProoductSubGroup = [];
      this.selectedProoductCG = [];
      this.searchFilterProductCode = "";
      this.searchFilterProductName = "";
      this.tbListProduct = [];
      this.checkedProductFilterAll = false;
      this.checkedProductFilter = [];
    },
    defaultValueStart() {
      if (this.C3 == 0) {
        this.C3_start = 0;
        this.C2_start = parseInt(this.A3) + 1;
      } else {
        this.C3_start = parseInt(this.A3) + 1;
        this.C2_start = parseInt(this.C3) + 1;
      }
      this.C1_start = parseInt(this.C2) + 1;
      this.C0_start = parseInt(this.C1) + 1;
    },
    isOwner(c_user) {
      if (this.user.username == c_user) return true;
      else return false;
    },
    calGPbyRow(val) {
      let vCost = val.cost && val.cost != null ? val.cost : 0;
      // let vA3 = (val.qty_a3 && val.qty_a3 != null) ? val.qty_a3 : 0;
      let vC0 = val.qty_c0 && val.qty_c0 != null ? val.qty_c0 : 0;
      let comCOST = parseFloat(this.formatNumber(vCost, 2).replace(",", ""));
      let COST = Math.round(parseFloat(comCOST) * 100) / 100;
      // let comA3 = parseFloat(this.formatNumber(vA3, 2).replace(',', ''));
      let comC0 = parseFloat(this.formatNumber(vC0, 2).replace(",", ""));
      // let A3 = Math.round(parseFloat(comA3) * 100) / 100;
      let C0 = Math.round(parseFloat(comC0) * 100) / 100;
      // let gp = (A3 == 0) ? 0 : ((A3 - COST) / A3) * 100;
      let gp = C0 == 0 ? 0 : ((C0 - COST) / C0) * 100;
      return this.formatNumber(gp, 2);
    },
    calSumOf(value) {
      let vCost =
        value.cost && value.cost != "" && value.cost != null ? value.cost : 0;
      let commaCost = parseFloat(this.formatNumber(vCost, 2).replace(",", ""));
      let calCost = Math.round(parseFloat(commaCost) * 100) / 100;

      let vA3 =
        value.price && value.price.A3 && value.price.A3 != null
          ? value.price.A3
          : 0;
      let vC0 =
        value.price && value.price.C0 && value.price.C0 != null
          ? value.price.C0
          : 0;
      let commaA3 = parseFloat(this.formatNumber(vA3, 2).replace(",", ""));
      let commaC0 = parseFloat(this.formatNumber(vC0, 2).replace(",", ""));
      let calA3 = Math.round(parseFloat(commaA3) * 100) / 100;
      let calC0 = Math.round(parseFloat(commaC0) * 100) / 100;

      this.sumCost += calCost;
      this.sumA3 += calA3;
      this.sumC0 += calC0;
    },
    filterTable() {
      let self = this;
      this.arrsTable = this.createDatasOld.filter(function(val) {
        if (
          val.item_code.indexOf(self.vFilter.trim()) > -1 ||
          val.item_name.indexOf(self.vFilter.trim()) > -1
        ) {
          return self.arrsTable.push(val);
        }
      });
      this.createDatas = this.arrsTable;

      if (this.vFilter == "") {
        this.checkedProductsAll = false;
      }
    },
    nameWithLang({ item_code, item_name }) {
      return `${item_code} - ${item_name}`;
    },
    loadOptions({ action, searchQuery, callback }) {
      let self = this;
      let text = "";
      // let type = 'input';
      let type = "paste";
      if (searchQuery.split(" ").length <= 1) {
        text = searchQuery;
      } else {
        let splitText = searchQuery.split(" ");
        if (splitText.length < 1000) {
          let texts = "";
          splitText.forEach(function(value, key) {
            texts += value + ",";
          });
          text = texts.substring(0, texts.length - 1);
          type = "paste";
        } else {
          this.dContent = "Data input text have Code more than 1000 Code.";
          this.showSnackbar = true;
          return false;
        }
      }

      let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
      if (action === ASYNC_SEARCH && text.length > 1) {
        simulateAsyncOperation(() => {
          PricingService.ProductTree(text, type, this.checkDataDelete, emp_code)
            .then(response => {
              self.optionsTreeview = response.data;
              self.dataLoaded = response.data;
              if (response.message.length > 0) {
                self.alertProductLost = "";
                // self.alertProductLost = response.message;
                let length = response.message.length - 1;
                response.message.forEach(function(value, key) {
                  self.alertProductLost += key == length ? value : value + ", ";
                });
                self.showDialogAlert = true;
              }

              if (type == "paste") {
                this.dataLoaded.forEach(function(value, key) {
                  let index = self.valueTree
                    .map(function(e) {
                      return e;
                    })
                    .indexOf(value.id);

                  if (index == -1) {
                    self.valueTree.push(value.id);
                    self.calSumOf(value);
                    self.setDataArrayTree("last", value);
                  }
                });
                if (this.dataLoaded.length >= 1) {
                  let input_search = self.$refs.productTxt;
                  let real_input = input_search.$el.querySelector(
                    ".vue-treeselect__input"
                  );
                  real_input.value = "";
                }
              }

              callback(null, self.optionsTreeview);
            })
            .catch();
        });
      }
    },
    openOnSelectTreeview(node) {
      let self = this;
      if (node.children) {
        node.children.forEach(function(value, key) {
          if (value.children) {
            self.openOnSelectTreeview(value);
          } else {
            //Check ตัวแม่จาก level รองสุดท้าย
            self.calSumOf(value);
            self.setDataArrayTree("", value);
          }
        });
      } else {
        //Check last level
        self.calSumOf(node);
        self.setDataArrayTree("last", node);
      }
    },
    onDeSelectTreeview(node) {
      // console.log("node DeSelect==>", node);
      let self = this;
      if (node.children) {
        node.children.forEach(function(value, key) {
          if (value.children) {
            self.onDeSelectTreeview(value);
          } else {
            //Check ตัวแม่จาก level รองสุดท้าย
            let index = self.createDatas
              .map(function(e) {
                return e.id;
              })
              .indexOf(value.id);
            if (index > -1) {
              let vCost =
                self.createDatas[index].cost &&
                self.createDatas[index].cost != ""
                  ? self.createDatas[index].cost
                  : 0;
              let commaCost = parseFloat(
                self.formatNumber(vCost, 2).replace(",", "")
              );
              let calCost = Math.round(parseFloat(commaCost) * 100) / 100;

              let vA3 =
                self.createDatas[index].qty_a3 &&
                self.createDatas[index].qty_a3 != ""
                  ? self.createDatas[index].qty_a3
                  : 0;
              let vC0 =
                self.createDatas[index].qty_c0 &&
                self.createDatas[index].qty_c0 != ""
                  ? self.createDatas[index].qty_c0
                  : 0;
              let commaA3 = parseFloat(
                self.formatNumber(vA3, 2).replace(",", "")
              );
              let commaC0 = parseFloat(
                self.formatNumber(vC0, 2).replace(",", "")
              );
              let calA3 = Math.round(parseFloat(commaA3) * 100) / 100;
              let calC0 = Math.round(parseFloat(commaC0) * 100) / 100;

              self.sumCost -= calCost;
              self.sumA3 -= calA3;
              self.sumC0 -= calC0;

              self.createDatas.splice(index, 1);
              self.checkedProducts.splice(index, 1);
              self.checkedLengthProducts.splice(index, 1);
            }
          }
        });
      } else {
        //Check last level
        let index = self.createDatas
          .map(function(e) {
            return e.id;
          })
          .indexOf(node.id);

        let vCost =
          self.createDatas[index].cost && self.createDatas[index].cost != ""
            ? self.createDatas[index].cost
            : 0;
        let commaCost = parseFloat(
          self.formatNumber(vCost, 2).replace(",", "")
        );
        let calCost = Math.round(parseFloat(commaCost) * 100) / 100;

        let vA3 =
          self.createDatas[index].qty_a3 && self.createDatas[index].qty_a3 != ""
            ? self.createDatas[index].qty_a3
            : 0;
        let vC0 =
          self.createDatas[index].qty_c0 && self.createDatas[index].qty_c0 != ""
            ? self.createDatas[index].qty_c0
            : 0;
        let commaA3 = parseFloat(self.formatNumber(vA3, 2).replace(",", ""));
        let commaC0 = parseFloat(self.formatNumber(vC0, 2).replace(",", ""));
        let calA3 = Math.round(parseFloat(commaA3) * 100) / 100;
        let calC0 = Math.round(parseFloat(commaC0) * 100) / 100;

        self.sumCost -= calCost;
        self.sumA3 -= calA3;
        self.sumC0 -= calC0;

        self.createDatas.splice(index, 1);
        self.checkedProducts.splice(index, 1);
        self.checkedLengthProducts.splice(index, 1);
      }

      this.createDatasOld = [];
      this.createDatasOld = this.createDatas;
      // console.log("this.dataTreeview DE-SELECT ==>", this.dataTreeview);

      let comCOST = parseFloat(
        this.formatNumber(this.sumCost, 2).replace(",", "")
      );
      let COST = Math.round(parseFloat(comCOST) * 100) / 100;
      let comA3 = parseFloat(this.formatNumber(this.sumA3, 2).replace(",", ""));
      let comC0 = parseFloat(this.formatNumber(this.sumC0, 2).replace(",", ""));
      let A3 = Math.round(parseFloat(comA3) * 100) / 100;
      let C0 = Math.round(parseFloat(comC0) * 100) / 100;
      this.sumGP = C0 == 0 ? 0 : ((C0 - COST) / C0) * 100;
    },
    onOpenTreeview() {
      this.vFilter = "";
      this.filterTable();
    },
    setDataArrayTree(check, value) {
      let index = this.createDatas
        .map(function(e) {
          return e.id;
        })
        .indexOf(value.id);

      if (index == -1) {
        //ไม่เจอ
        let datas = {
          id: value.id,
          item_cg: value.cg,
          item_name: value.item_name,
          item_code: value.code,
          stock: value.stock ? value.stock : "",
          cost: value.cost ? value.cost : "",
          // gp: (value.gp) ? value.gp : "",
          qty_a3:
            value.price && value.price.A3 && value.price.A3 != null
              ? value.price.A3
              : "",
          qty_c0:
            value.price && value.price.C0 && value.price.C0 != null
              ? value.price.C0
              : "",
          qty_c1:
            value.price && value.price.C1 && value.price.C1 != null
              ? value.price.C1
              : "",
          qty_c2:
            value.price && value.price.C2 && value.price.C2 != null
              ? value.price.C2
              : "",
          qty_c3:
            value.price && value.price.C3 && value.price.C3 != null
              ? value.price.C3
              : "",
          // qty_a3: (value.qty_a3) ? value.qty_a3 : "",
          // qty_c0: (value.qty_c0) ? value.qty_c0 : "",
          // qty_c1: (value.qty_c1) ? value.qty_c1 : "",
          // qty_c2: (value.qty_c2) ? value.qty_c2 : "",
          saleprice_um_title: value.selling_um_title,
          selling_um_title: value.selling_um_title
        };
        if (check == "last") {
          let key = this.dataTreeview.length;
          this.dataTreeview[key] = datas;
        } else {
          this.dataTreeview.push(datas);
        }

        this.checkedProducts.push(value.code);
      }

      // this.checkedProducts.push(value.code);
      let arrs = this.createDatas.concat(this.dataTreeview);
      this.createDatas = arrs;
      this.dataTreeview = [];
      this.createDatasOld = [];
      this.createDatasOld = this.createDatas;
      // this.checkedProducts.push(this.createDatas[itemCode].item_code);
      // this.createDatas = this.dataTreeview;

      let comCOST = parseFloat(
        this.formatNumber(this.sumCost, 2).replace(",", "")
      );
      let COST = Math.round(parseFloat(comCOST) * 100) / 100;
      let comA3 = parseFloat(this.formatNumber(this.sumA3, 2).replace(",", ""));
      let comC0 = parseFloat(this.formatNumber(this.sumC0, 2).replace(",", ""));
      let A3 = Math.round(parseFloat(comA3) * 100) / 100;
      let C0 = Math.round(parseFloat(comC0) * 100) / 100;
      // this.sumGP = (A3 == 0) ? 0 : ((A3 - COST) / A3) * 100;
      this.sumGP = C0 == 0 ? 0 : ((C0 - COST) / C0) * 100;
      // console.log("this.createDatas ==>", this.createDatas.length);
    },
    formatNumber(value, dicimal) {
      if (isNaN(parseFloat(value))) {
        let val = 0;
        return val.toFixed(dicimal);
        // return value;
      } else {
        if (value % 1 == 0) {
          return parseFloat(value).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal
          });
        } else {
          let parts = value.toString().split(".");
          let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
          let digit = parts[1].slice(0, 3);
          digit = digit.length < 2 ? digit + "0" : digit;
          let rs = num + "." + digit;
          let comma = parseFloat(rs.replace(",", ""));
          // return Math.round(parseFloat(comma) * 100) / 100;
          return parseFloat(
            Math.round(parseFloat(comma) * 100) / 100
          ).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal
          });
        }
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        this.keepEvent = false;
        evt.preventDefault();
      } else {
        this.keepEvent = true;
        return true;
      }
    },
    selectAll() {
      this.checkedProducts = [];
      if (!this.checkedProductsAll) {
        for (let itemCode in this.createDatas) {
          this.checkedProducts.push(this.createDatas[itemCode].item_code);
        }
      }
      this.checkedLengthProducts = this.checkedProducts;
    },
    deleteProduct() {
      this.dContent = "Are you sure you want to delete ?";
      this.showDialogDeleteItem = true;
    },
    switchCheck() {
      if (this.mixSwitch == true) {
        this.dContent = 'Are you sure you want to "Mixable"';
      } else {
        this.dContent = 'Are you sure you want to "Independent"';
      }
      this.showDialogMix = true;
    },
    onDeleteProduct() {
      this.$emit("clickDelete", this.value._id);
    },
    onDeleteItem() {
      let self = this;
      this.checkedProducts.forEach(function(value, key) {
        if (
          self.checkDataDelete.length == 0 ||
          self.checkDataDelete.indexOf(value) == -1
        ) {
          self.checkDataDelete.push(value);
        }

        let setDataRow = self.createDatasOld
          .map(function(e) {
            return e.item_code;
          })
          .indexOf(value);

        if (setDataRow > -1) {
          let vCost =
            self.createDatasOld[setDataRow].cost &&
            self.createDatasOld[setDataRow].cost != ""
              ? self.createDatasOld[setDataRow].cost
              : 0;
          let commaCost = parseFloat(
            self.formatNumber(vCost, 2).replace(",", "")
          );
          let calCost = Math.round(parseFloat(commaCost) * 100) / 100;

          let vA3 =
            self.createDatasOld[setDataRow].qty_a3 &&
            self.createDatasOld[setDataRow].qty_a3 != ""
              ? self.createDatasOld[setDataRow].qty_a3
              : 0;
          let vC0 =
            self.createDatasOld[setDataRow].qty_c0 &&
            self.createDatasOld[setDataRow].qty_c0 != ""
              ? self.createDatasOld[setDataRow].qty_c0
              : 0;
          let commaA3 = parseFloat(self.formatNumber(vA3, 2).replace(",", ""));
          let commaC0 = parseFloat(self.formatNumber(vC0, 2).replace(",", ""));
          let calA3 = Math.round(parseFloat(commaA3) * 100) / 100;
          let calC0 = Math.round(parseFloat(commaC0) * 100) / 100;

          self.sumCost -= calCost;
          self.sumA3 -= calA3;
          self.sumC0 -= calC0;

          self.createDatasOld.splice(setDataRow, 1);
          self.valueTree.splice(setDataRow, 1);
        }
      });

      let comCOST = parseFloat(
        self.formatNumber(this.sumCost, 2).replace(",", "")
      );
      let COST = Math.round(parseFloat(comCOST) * 100) / 100;
      let comA3 = parseFloat(self.formatNumber(this.sumA3, 2).replace(",", ""));
      let comC0 = parseFloat(self.formatNumber(this.sumC0, 2).replace(",", ""));
      let A3 = Math.round(parseFloat(comA3) * 100) / 100;
      let C0 = Math.round(parseFloat(comC0) * 100) / 100;
      // this.sumGP = (A3 == 0) ? 0 : ((A3 - COST) / A3) * 100;
      this.sumGP = C0 == 0 ? 0 : ((C0 - COST) / C0) * 100;

      this.checkedProducts = [];
      this.checkedProductsAll = false;
      this.createDatas = [];
      this.createDatas = this.createDatasOld;
      this.vFilter = "";
      this.filterTable();
    },
    onOk() {
      this.mixSwitch = this.mixSwitch == true ? true : false;
    },
    onClose() {
      this.mixSwitch = this.mixSwitch == true ? false : true;
    },
    mouseOver(rIndex) {
      this.rowBgGray = !this.rowBgGray;
    },
    onClickCancel() {
      if (this.displayData == false || this.value._id === undefined) {
        //CANCEL
        this.showDialogCancel = true;
      } else {
        //CLOSE
        this.showDialog = false;
        this.$emit("clickCancel", "close");
      }
    },
    onConfirm() {
      //this.$emit("clickCancel", "true");
      this.$emit("clickCancel", this.dataDelete);
    },
    onCancel() {
      // console.log("CANCEL");
    },
    onSave() {
      // console.log("-- SAVE --");
      // console.log("this.createDatas ==>", this.createDatas);

      let self = this;
      this.makeDataDetail = [];
      this.createDatas.forEach(function(value, key) {
        self.makeDataDetail.push({
          id: value.id,
          item_cg: value.item_cg,
          item_code: value.item_code,
          item_name: value.item_name,
          cost: value.cost ? value.cost : "",
          // gp: (value.gp) ? value.gp : "",
          qty_a3: value.qty_a3,
          qty_c0: value.qty_c0,
          qty_c1: value.qty_c1,
          qty_c2: value.qty_c2,
          qty_c3: value.qty_c3,
          saleprice_um_title: value.saleprice_um_title,
          selling_um_title: value.selling_um_title,
          avg_purchase: "-",
          total: "-"
        });
      });

      let _id = "",
        vType = "";

      this.value.length == 0 ? (_id = "") : (_id = this.value._id);
      this.mixSwitch == true ? (vType = "Mixable") : (vType = "Indipendent");

      let tmp_start_c3 = 0;
      let tmp_end_c3 = 0;
      let tmp_start_c2 = parseInt(this.A3) + 1;
      if (this.C3 != 0 && this.C3 !== "" && this.C3 !== null) {
        tmp_start_c3 = parseInt(this.A3) + 1;
        tmp_end_c3 = parseInt(this.C3);
        tmp_start_c2 = parseInt(this.C3) + 1;
      }

      let config_end_c3 = this.C3 === "" || this.C3 === null ? 0 : this.C3;

      this.dataSave = {
        _id: _id,
        h_name: this.vTitle.trim(),
        h_detail:
          this.vDetail === undefined || this.vDetail == ""
            ? ""
            : this.vDetail.trim(),
        type: vType,
        desc: this.vDesscription.trim(),
        details: this.makeDataDetail,
        qty_a3: [
          {
            // start: 1,
            start: parseInt(this.A3_start),
            end: parseInt(this.A3)
          }
        ],
        qty_c3: [
          {
            // start: tmp_start_c3,
            // end: tmp_end_c3
            start: parseInt(this.C3_start),
            end: parseInt(config_end_c3)
            // end: parseInt(this.C3)
          }
        ],
        qty_c2: [
          {
            // start: tmp_start_c2,
            // end: parseInt(this.C2)
            start: parseInt(this.C2_start),
            end: parseInt(this.C2)
          }
        ],
        qty_c1: [
          {
            // start: parseInt(this.C2) + 1,
            // end: parseInt(this.C1)
            start: parseInt(this.C1_start),
            end: parseInt(this.C1)
          }
        ],
        qty_c0: [
          {
            // start: parseInt(this.C1) + 1,
            start: parseInt(this.C0_start),
            end: ""
          }
        ]
      };
      this.$emit("clickSave", this.dataSave);
    },
    onClickSave() {
      this.vFilter = "";
      this.filterTable();

      if (this.vTitle == " " || this.vTitle == "" || this.vTitle == null) {
        this.dContent = 'Please fill required fields "Title"';
        this.showSnackbar = true;
      } else if (this.createDatas.length == 0) {
        this.dContent = 'Please select "Product"';
        // this.dAlert = true;
        this.showSnackbar = true;
      } else if (
        (this.C3_start == 0 && this.C3 != 0) ||
        (this.C3_start != 0 && this.C3 == 0)
      ) {
        this.dContent = "Please Check Quantity Condition.";
        this.showSnackbar = true;
      }
      // else if (
      //     (this.C3_start == 0 && this.C3 == 0) &&
      //     (
      //         (this.A3_start == null || this.C2_start == null || this.C1_start == null || this.C0_start == null) ||
      //         (this.A3_start == "" || this.C2_start == "" || this.C1_start == "" || this.C0_start == "") ||
      //         (this.A3 == null || this.C2 == null || this.C1 == null || this.A3 == "" || this.C2 == "" || this.C1 == "") ||
      //         (this.A3_start == 0 || this.A3_start >= this.A3 || this.A3 >= this.C2_start) ||
      //         (this.C2_start >= this.C2 || this.C2 >= this.C1_start) ||
      //         (this.C1_start >= this.C1 || this.C1 >= this.C0_start)
      //     )
      // ) {
      //     this.dContent = "Please Check Quantity Condition.";
      //     this.showSnackbar = true;
      // } else if (
      //     /* 5.10 p'mc C3 can input 0
      //      * parseInt(this.C3) <= parseInt(this.A3) ||
      //      * */

      //     /* START Change 22.05.2019 : Trello #257 */
      //     // parseInt(this.A3) <= 1 ||
      //     // (parseInt(this.C3) > 0 && parseInt(this.C3) <= parseInt(this.A3)) ||
      //     // parseInt(this.C2) <= parseInt(this.C3) ||
      //     // parseInt(this.C1) <= parseInt(this.C2) ||
      //     // this.A3 == null || this.C2 == null || this.C1 == null ||
      //     // this.A3 == "" || this.C2 == "" || this.C1 == ""

      //     (this.C3_start != 0 && this.C3 != 0) &&
      //     (
      //         (this.A3_start == null || this.C2_start == null || this.C1_start == null || this.C0_start == null) ||
      //         (this.A3_start == "" || this.C2_start == "" || this.C1_start == "" || this.C0_start == "") ||
      //         (this.A3 == null || this.C2 == null || this.C1 == null || this.A3 == "" || this.C2 == "" || this.C1 == "") ||
      //         (this.A3_start == 0 || this.A3_start >= this.A3 || this.A3 >= this.C3_start) ||
      //         (this.C3_start >= this.C3 || this.C3 >= this.C2_start) || // มีการกรอกค่า C3
      //         (this.C2_start >= this.C2 || this.C2 >= this.C1_start) ||
      //         (this.C1_start >= this.C1 || this.C1 >= this.C0_start)
      //     )
      //     /* END Change 22.05.2019 : Trello #257 */
      // ) {
      //     this.dContent = "Please Check Quantity Condition.";
      //     // this.dAlert = true;
      //     this.showSnackbar = true;
      // }
      else if (
        this.C3 == 0 &&
        (this.A3 < this.A3_start ||
          this.A3 >= this.C2_start ||
          this.C2 < this.C2_start ||
          this.C2 >= this.C1_start ||
          this.C1 < this.C1_start)
      ) {
        this.dContent = "Please Check Quantity Condition.";
        // this.dAlert = true;
        this.showSnackbar = true;
      } else if (
        this.C3 != 0 &&
        (this.A3 < this.A3_start ||
          this.A3 >= this.C3_start ||
          this.C3 < this.C3_start ||
          this.C3 >= this.C2_start ||
          this.C2 < this.C2_start ||
          this.C2 >= this.C1_start ||
          this.C1 < this.C1_start)
      ) {
        this.dContent = "Please Check Quantity Condition.";
        // this.dAlert = true;
        this.showSnackbar = true;
      } else {
        //Save

        if (this.value.length == 0) {
          // Create
          this.dContent = "Are you sure you want to save ?";
        } else {
          //Edit
          this.dContent = "Are you sure you want to save changes ?";
        }
        this.showDialogSave = true;
      }
    },
    onClickEdit() {
      this.disabledInput = false;
      this.displayData = false;
    },
    onClickDelete() {
      let path = this.$route.path;
      let arr_path = path.split("/");
      let acl = this.$jwt.decode(localStorage.getItem("token")).acl;
      this.showDialogDeleteProduct = true;
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.volumepricing.dialog-alert {
  width: 50%;
  max-width: 50% !important;
  height: 60%;
  transform: unset !important;
  top: 20% !important;
  left: 25% !important;

  .dialog-content .scrollbar {
    overflow-y: scroll;
    height: calc(60vmin - 285px);

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }
  }

  .md-dialog-title {
    &.md-title {
      font-size: 18px;
      margin-bottom: 5px;
      padding: 21px 30px 0;
      font-weight: bold;
    }
  }

  .layout-dialog {
    padding: 10px 15px 5px 30px;
    display: block;
    height: 100%;
    font-size: 15px;

    .dialog-content {
      width: 100%;
      display: flex;
      margin-top: 10px;

      &.-conditions {
        margin-top: 30px;
        display: block;
        color: red;
        position: absolute;
        bottom: 55px;
        left: 30px;

        .title {
          font-weight: bold;
        }

        ul {
          margin: 10px;
        }

        ul,
        li {
          font-family: kanit;
          width: 100%;
          // color: red;
        }
      }
    }
  }

  .-action {
    padding-right: 15px;
    padding-bottom: 20px;

    .-confirm {
      color: #3f51b5;
      font-weight: bold;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}

.volumepricing.dialog-update {
  &.md-dialog {
    max-height: unset;
  }

  width: 95%;
  max-width: 95% !important;
  height: 90%;
  z-index: 5;
  transform: unset !important;
  top: 5% !important;
  left: 2.5% !important;

  .row-bg-gray:hover {
    border-radius: 4px;
    background: rgba(236, 236, 235, 1);
  }

  .md-dialog-title {
    &.md-title {
      font-size: 18px;
      margin-bottom: 5px;
      padding: 21px 30px 0;
      font-weight: bold;
    }

    .title-panel {
      position: fixed;
    }

    .md-menu {
      width: 101%;
      text-align: right;

      .-edit {
        color: #3f51b5;
        font-weight: bold;
        font-size: 16px;
        height: 25px;
        min-width: 20px;
      }

      .more-vert {
        height: 25px;
        width: 25px;
        min-width: 25px;

        .md-icon {
          color: #414141;
        }
      }
    }
  }

  .dialog-content {
    padding: 20px;
  }

  .-action {
    position: fixed;
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    // text-align: right;
    width: 100%;
    justify-content: flex-start;

    .md-switch,
    .md-button {
      margin: 0;
    }

    .md-switch {
      width: 72%;
      margin-left: 3px;
      font-size: 16px;
      color: #000000;
    }

    .md-button {
      width: 28%;
      text-align: right;
      justify-content: flex-end;
    }

    .md-button:not([disabled]):hover:before {
      background-color: unset;
    }

    .-cancel {
      color: #a8a8a8 !important;
      // margin-right: 10px;
      font-weight: bold;
      font-size: 16px;
    }

    .-confirm {
      color: #3f51b5;
      font-weight: bold;
      font-size: 16px;
      margin-left: 10px;
    }
  }

  .layout-dialog {
    padding: 10px 15px 5px 25px;
    display: flex;
    height: 100%;

    .dialog-left-panel {
      width: 25%;
      height: 100%;
      // background-color: pink;

      .-textarea {
        // padding-left: 14px;
        width: 100%;
        color: #727272;
        margin-top: 10px;

        textarea {
          width: 95% !important;
          min-width: 95%;
          max-width: 95%;
          min-height: 70px;
          max-height: 70px;
          font-size: 14px;
          font-family: kanit;
          margin-top: 10px;
          padding-left: 8px;
          padding-right: 13.8px;
          border: 1px solid #ddd;
          border-radius: 5px;
          background: #fff;
        }
        ::placeholder {
          color: #bdbdbd;
          opacity: 1;
          font-size: 14px;
          font-family: lato;
        }
      }
    }

    .dialog-right-panel {
      width: 75%;
      height: 100%;
      // background-color: plum;
    }

    .layout-input-value {
      .md-has-value > label {
        color: #727272;
      }

      .display-mode {
        font-size: 16px;
        color: #000000;
        margin-top: 4px;

        &.nowrap-title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }

        .-detail {
          white-space: pre-wrap;
          // height: 70px;
          // overflow-y: scroll;

          &::-webkit-scrollbar {
            height: 7px;
            width: 5px;
          }
        }
      }
    }

    .md-layout {
      padding-left: 7px;

      .quantity-condition {
        margin-top: 15px;
        padding-left: 7px;

        .display-flex {
          width: 100%;
          display: flex;
          text-align: center;

          .con-type {
            width: 20%;
            margin-top: 10px;
          }

          .value-type {
            // width: 22%;
            width: 65px;
          }

          .-null {
            // width: 10%;
            width: 30px;
            margin-top: 10px;
          }
        }

        > label {
          color: #000000;
          opacity: 1;
          font-size: 13px;
          // margin-right: 127px;
        }

        .-group-condition {
          // display: flex;
          font-size: 15px;
          margin-top: 3px;

          .display-flex {
            margin-top: 10px;
          }

          span {
            margin-top: 10px;
          }

          div {
            max-height: 32px;
          }

          .-md-input {
            padding-top: unset;
            width: 65px;
            min-height: 29.7px;
            background-color: #ffffff;
            border-radius: 4px;
            box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
              0 1px 1px -2px rgba(0, 0, 0, 0);

            &.md-field > .md-icon:after,
            &.md-field:after,
            &.md-field:before {
              content: none;
            }

            > input {
              z-index: 1;
              width: 58.5px;
              font-size: 14px;
              text-align: center;
              -webkit-text-fill-color: #3f51b5;
            }

            &.input-disabled {
              > input {
                background-color: #f1f1f1;
              }
            }

            > span {
              // margin-top: 31px;
              // margin-left: 24px;
              position: absolute;
              padding-top: 25px;
              padding-left: 24px;
              font-size: 11px;
              opacity: 0.5;
            }
          }

          .-flex-relative {
            display: flex;
            position: relative;
            color: #000000;

            #span-a3 {
              position: absolute;
              padding-top: 29px;
              font-size: 11px;
              opacity: 0.5;
            }

            #span-c0 {
              position: absolute;
              padding-top: 29px;
              padding-left: 40px;
              font-size: 11px;
              opacity: 0.5;
            }
          }
        }
      }

      &.-btn-right {
        text-align: right;

        .btn-cancel {
          background-color: rgb(153, 155, 168);
          color: white;
          width: 108.64px;
          height: 32px;
        }

        .btn-save {
          margin-right: 0px;
          width: 83.97px;
          height: 32px;
        }
      }

      .md-switch {
        margin-left: 7px;
        margin-bottom: 10px;
      }

      .-txt-items {
        // width: 12%;
        padding-top: 23px;
        padding-left: 3px;
        // color: #727272;
        font-size: 14px;
        font-weight: bold;
      }

      .-add-product {
        width: 25%;
        padding-top: 25px;
        font-size: 14px;
        font-weight: bold;
        color: #3f51b5;
        text-transform: uppercase;

        #add-product {
          cursor: pointer;
        }
      }

      .filter-table {
        // width: 35%;
        // margin-left: 85px;
        text-align: right;

        input {
          width: 85%;
          margin-top: 14px;
          padding-left: 8px;
          padding-right: 13.8px;
          height: 36px;
          border: 1px solid #ddd;
          border-radius: 5px;
          background: #fff;
        }

        ::placeholder {
          color: #bdbdbd;
          opacity: 1;
          font-family: kanit;
          font-size: 12px;
          font-weight: 100;
        }
      }

      .-delete-back {
        // width: 4%;
        // margin-left: 13.8px;
        color: #b3b3b3;
        cursor: pointer;
      }

      .mktops-control-box {
        margin-top: 5px;
        // margin-left: 22.73px;
        // width: 45%;

        .head-search-price {
          display: flex;

          .md-search-box {
            margin: 10px 10px 10px 0px;
            padding-top: unset;
            width: 80%;
            border-radius: 3px;
            min-height: 36px;
            box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
              0 1px 1px -2px rgba(0, 0, 0, 0);

            .md-icon.material-icons {
              margin-top: 6px;
              margin-left: 12px;
              margin-right: 5px;
              color: rgba(0, 0, 0, 0.54);

              &.-search-back {
                margin-top: 7px;
                margin-right: 10px;
              }
            }

            .md-input {
              height: 36px;
              margin-left: 7px;
            }

            &.md-field > .md-icon:after,
            &.md-field:after,
            &.md-field:before {
              content: none;
            }
          }
        }

        .treeview-box {
          width: 100%;
          margin-top: 9px;
          margin-bottom: 5px;

          .vue-treeselect__multi-value {
            margin: 0;
          }

          .vue-treeselect__multi-value-item-container {
            display: none;
          }

          .vue-treeselect__limit-tip-text {
            display: none;
          }

          .vue-treeselect__input-container {
            padding-top: 1px;
            padding-left: 5px;
          }

          .vue-treeselect__label-container {
            label {
              &.nowrap-title {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: block;
              }
            }
          }
        }
      }
    }
  }

  #table-update-scroll {
    #divHeadUpdate {
      width: 99.4%;
      display: -webkit-inline-box;
      font-size: 13px;
      font-weight: bold;
      margin-top: 7px;
      margin-bottom: 11px;
      // color: #8a8a8a;

      &.display {
        margin-top: 21px;
      }

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;

        &.-text-right {
          text-align: right;

          &.-usage {
            padding-right: 13px;
          }
        }

        &.-text-center {
          text-align: center;
        }

        .md-checkbox {
          margin: 0;
          padding: 0;
        }
      }
    }

    #divBodyUpdate {
      width: 100%;
      display: block;
      height: calc(90vmin - 240px);
      overflow-y: scroll;
      font-size: 13px;

      &.display {
        height: calc(90vmin - 198px);
      }

      > div {
        width: 100%;
        display: -webkit-inline-box;
        padding-top: 4px;
        padding-bottom: 4px;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .md-checkbox {
            margin: 0;
            padding: 0;
          }
        }
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }

    #divTableFoot {
      width: 99.4%;
      display: -webkit-inline-box;
      font-weight: bold;
      font-size: 13px;
      margin-top: 8px;
      margin-bottom: 8px;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }

    .footer-table {
      // border: 1px solid pink;
      display: block;
      text-align: center;
      // margin-top: 5px;
      width: 99.6%;
      font-size: 14px;
      font-style: italic;
    }
  }

  .mkt-datepicker {
    width: 100%;

    input {
      font-size: 14px;
    }

    .md-field .md-input-action {
      top: 15px;
    }
  }
}

.md-menu-content-big.menu-vert-volume {
  z-index: 20;
  top: 80px !important;
  left: unset !important;
  right: 50px !important;
  min-width: 149px !important;
}

.dialog-filter-product {
  &.-w90 {
    //     width: 95%;
    //     max-width: 95% !important;
    //     height: 90%;
    //     transform: unset !important;
    //     top: 5% !important;
    //     left: 2.5% !important;

    #table-product-filter {
      #divBodyList {
        height: calc(95vmin - 290px);

        .-disabled {
          color: #b6b6b6;
          font-style: italic;
        }

        .-mkt-checkbox.-disabled {
          border: 1.5px solid #cacaca;
          background-color: #ececec;
          cursor: text;
        }
      }
    }
  }

  .bg-backdrop-pricing {
    background: rgba(0, 0, 0, 0.35);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 15;
    top: 0;
    left: 0;
  }
}
</style>
